var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 25.143",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-calendar-check",
    d: "M21.411 7.857H.589A.589.589 0 010 7.268V5.5a2.357 2.357 0 012.357-2.357h2.357V.589A.589.589 0 015.3 0h1.968a.589.589 0 01.589.589v2.554h6.286V.589A.589.589 0 0114.732 0H16.7a.589.589 0 01.589.589v2.554h2.357A2.357 2.357 0 0122 5.5v1.768a.589.589 0 01-.589.589zM.589 9.429h20.822a.589.589 0 01.589.589v12.768a2.357 2.357 0 01-2.357 2.357H2.357A2.357 2.357 0 010 22.786V10.018a.589.589 0 01.589-.589zm16.367 4.711l-1.383-1.395a.589.589 0 00-.833 0l-5.207 5.163-2.258-2.277a.589.589 0 00-.833 0l-1.395 1.38a.589.589 0 000 .833l4.053 4.09a.589.589 0 00.833 0l7.02-6.964a.589.589 0 000-.833z"
  })));
}

export default SvgCalendarChecked;